import { createAction, props } from "@ngrx/store";
import { Country } from "./shared.interface";


export const fetchCountries = createAction("[Shared Module] fetch countries");

export const fetchCountriesFailed = createAction(
  "[Shared Module] STATUS: fetch countries failed"
);

export const fetchCountriesSuccess = createAction(
  "[Shared Module] STATUS: fetch countries success",
  props<{ countries: Country[] }>()
);

